// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 729 ? "4d022aba" : chunkId) + "." + {"313":"f6cf068fad8a48dd","425":"ee4d8dc70a2be390","436":"d3bdf4b1d27ea783","729":"5bf90dddbf4ac190","752":"32e5fb6c789fac05","902":"d351109131fa010f","954":"aa8591d15e887ba2","961":"63be0b3f583e2e5d","974":"b3c892aa06c942f8"}[chunkId] + ".js";
};